import React, { useState, useEffect } from 'react';
import * as FiIcons from 'react-icons/fi';
import { useNavigate, useLocation } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';

const { FiMenu, FiX } = FiIcons;

const navLinks = [
  { name: 'Services', href: '#services', page: '/' },
  { name: 'Road Map', href: '#roadmap', page: '/' },
  { name: 'Case Studies', href: '/case-studies', page: 'route' },
  { name: 'Blog', href: '#blog', page: '/' },
  { name: 'Contact', href: '#strategy', page: '/' },
];

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const isCaseStudies = location.pathname === '/case-studies';

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNav = (link) => {
    setMobileOpen(false);
    if (link.page === 'route') {
      navigate(link.href);
    } else {
      if (isCaseStudies) {
        navigate('/');
        setTimeout(() => {
          const el = document.querySelector(link.href);
          if (el) el.scrollIntoView({ behavior: 'smooth' });
        }, 100);
      } else {
        const el = document.querySelector(link.href);
        if (el) el.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  const isLight = scrolled || isCaseStudies;

  return (
    <nav className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${isLight ? 'bg-white/96 backdrop-blur-md py-3 shadow-lg shadow-gray-100/50' : 'bg-transparent py-5'}`}>
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex justify-between items-center">
        <button onClick={() => navigate('/')} className="flex items-center gap-2">
          <div className="border border-white/40 px-2 py-1 flex items-center gap-2" style={{ borderColor: isLight ? '#ccc' : 'rgba(255,255,255,0.4)' }}>
            <div className="w-7 h-7 rounded-full border-2 border-[#8cc63f] flex items-center justify-center">
              <svg viewBox="0 0 24 24" fill="none" className="w-4 h-4 text-[#8cc63f]">
                <path d="M14 8h-4v8h4M10 12h3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M10 8c-2.21 0-4 1.79-4 4s1.79 4 4 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
              </svg>
            </div>
            <span className={`text-lg font-normal tracking-wide ${isLight ? 'text-gray-900' : 'text-white'}`}>
              <span className="text-[#8cc63f]">Get</span>Cleaning<span className="text-[#8cc63f]">Clicks</span>
            </span>
          </div>
        </button>

        <div className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <button
              key={link.name}
              onClick={() => handleNav(link)}
              className={`text-sm font-medium transition-colors hover:text-[#8cc63f] ${isLight ? 'text-gray-600' : 'text-white/90'}`}
            >
              {link.name}
            </button>
          ))}
        </div>

        <button
          onClick={() => handleNav({ href: '#strategy', page: '/' })}
          className="hidden md:inline-flex px-5 py-2.5 bg-[#8cc63f] hover:bg-[#7ab535] text-white text-sm font-semibold rounded-full transition-all shadow-lg shadow-[#8cc63f]/30"
        >
          Get Free Strategy Session
        </button>

        <button className="md:hidden text-2xl" onClick={() => setMobileOpen(!mobileOpen)}>
          {mobileOpen
            ? <FiX className={isLight ? 'text-gray-900' : 'text-white'} />
            : <FiMenu className={isLight ? 'text-gray-900' : 'text-white'} />}
        </button>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-white border-t border-gray-100 px-6 py-4 space-y-3">
          {navLinks.map((link) => (
            <button
              key={link.name}
              onClick={() => handleNav(link)}
              className="block w-full text-left text-gray-700 font-medium py-2 hover:text-[#8cc63f]"
            >
              {link.name}
            </button>
          ))}
          <button
            onClick={() => handleNav({ href: '#strategy', page: '/' })}
            className="block w-full text-center py-3 bg-[#8cc63f] text-white font-semibold rounded-full mt-2"
          >
            Get Free Strategy Session
          </button>
        </div>
      )}
    </nav>
  );
};

export default Navbar;